export default __webpack_public_path__ + "static/media/FONDO_FRIJOLES.ce4f4504.png";